import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const SendReminderModalUI = ({ context, messageList, successMsg, errorList, setErrorList,
  // modes
  sendMode, submitted,
  // event handlers
  onSubmit, onCancelClick
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_send_reminder'
    buttonMessageKey='c_send'
    cancelMessageKey='c_cancel'
    isOpen={sendMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
  </ModalFormUI>

export default SendReminderModalUI
